module.exports = __webpack_public_path__ + "static/media/cover1.ee2d0971.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/cover1.png
// module id = 554
// module chunks = 0